import * as THREE from 'three'


 
  export const ArbeitsweltLabels = [
    {
      Id: "Annotation_picGalerieSolemessung",
      Titel: "Galerie Berufsbilder 1",
      TitelEn: "Gallery job profiles 1",
      Position: new THREE.Vector3(-76.6274, 20.5651, 640.746),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: -3,
      follow: false,
      lowModelCamZoom: 20
    },

    {
      Id: "Annotation_picGalerieVorstaende",
      Titel: "Galerie Berufsbilder 3",
      TitelEn: "Gallery job profiles 3",
      Position: new THREE.Vector3(-271.018, 26.1175, 664.274),
      Rotation: new THREE.Vector3(0.0,0.0,240),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },

    {
      Id: "Annotation_picGalerieAufsumpfen",
      Titel: "Galerie Berufsbilder 2",
      TitelEn: "Gallery job profiles 2",
      Position: new THREE.Vector3(-202.196, 19.1398, 712.663),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: -3,
      follow: false,
      lowModelCamZoom: 20
    },


    {
      Id: "Annotation_HandlederRechteckig",
      Titel: "Handleder",
      TitelEn: "Hand leather",
      Position: new THREE.Vector3(-107.492, 3.84, 471.746),
      Rotation: new THREE.Vector3(0.0, 0.0,0),
      Scale: 1,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/8853b8b7f9284b228404b98f7eeb6bea/embed",
      offset: 10,
      offsetUp: 20,
      follow: true,
      lowModelCamZoom: 15
    },
  
    {
      Id: "Annotation_Bergwerkschuh",
      Titel: "Lederschuh",
      TitelEn: "Leather shoe",
      Position: new THREE.Vector3(-158.922, 3.83906, 501.439),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1,
      isIFrame: true,
      iFrameUrl:
        "",
      offset: -14,
      offsetUp: 20,
      follow: true,
      lowModelCamZoom: 15
    },

    {
        Id: "Annotation_Bergmannshut",
        Titel: "Bergmannshut",
        TitelEn: "Miner's hat",
        Position: new THREE.Vector3(-190.628, 3.83906, 625.568),
        Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
        Scale: 1.3,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/53c7694e4cee4f9497361e08055793b9/embed",
        offset: 18,
        offsetUp: 20,
        follow: true,
        lowModelCamZoom: 15
      },



  ];


  export const HeimatLabels = [
    {
      Id: "Annotation_FaschingDetail",
      Titel: "Seine Hoheit Karneval",
      TitelEn: "His Highness Carnival",
      Position: new THREE.Vector3(53.8564, 27.6609, 632.338),
      Rotation: new THREE.Vector3(0.0,0.0,-30),
      Scale: 1,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: -3,
      follow: false,
      lowModelCamZoom: 20
    },

    {
      Id: "Annotation_Miasteufel",
      Titel: "Miasteufel",
      TitelEn: "Miasteufel",
      Position: new THREE.Vector3(38.731, 3.84, 741.9),
      Rotation: new THREE.Vector3(0.0, 0.0,0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/1f6ca19db54d42a098a39ec9a2dd7ff7/embed",
      offset: 25,
      offsetUp: 25,
      follow: true,
      lowModelCamZoom: 40
    },
  
    {
      Id: "Annotation_Flinserl",
      Titel: "Flinserl",
      TitelEn: "Flinserl",
      Position: new THREE.Vector3(92.2099, 3.84, 830.777),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/b54703dcd2da43d7ab2eff6c13848c70/embed",
      offset: 18,
      offsetUp: 25,
      follow: true,
      lowModelCamZoom: 30
    
    },

    {
      Id: "Annotation_Trommelweibertrommel",
      Titel: "Trommelweibertrommel",
      TitelEn: "Carnival drum",
      Position: new THREE.Vector3(57.5053, 3.84, 904.492),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/760113dec81144cdb3c4aae6e26a1410/embed",
      offset: 0,
      offsetUp: 20,
      follow: true,
      lowModelCamZoom: 20
    },

    {
      Id: "Annotation_Pfeifferl",
      Titel: "Pfeifferl",
      TitelEn: "Small flute",
      Position: new THREE.Vector3(-98.1856, 3.84, 734.63),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/51a03b497a66460fabff9186f3602990/embed",
      offset: 15,
      offsetUp: 20,
      follow: true,
      lowModelCamZoom: 15
    },




  ];

  export const GlaubeLabels = [
    {
      Id: "Annotation_picGalerieLandler",
      Titel: "Galerie Die Landler",
      TitelEn: "„Landler’s“ gallery",
      Position: new THREE.Vector3(463.987, 20.5651, 1108.38),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: -3,
      follow: false,
      lowModelCamZoom: 20
    },
    {
      Id: "Annotation_Barbara",
      Titel: "Die Heilige Barbara",
      TitelEn: "Saint Barbara",
      Position: new THREE.Vector3(740.39, 6.36533, 864.544),
      Rotation: new THREE.Vector3(0.0,0.0,60.0),
      Scale: 2,
      isIFrame: true,
      iFrameUrl:
        "",
      offset: -10,
      offsetUp: 20,
      follow: false
    },
  
    {
      Id: "Annotation_BuchLebenChristiGeschlossen",
      Titel: "Katholisches Gebetbuch",
      TitelEn: "Catholic prayer book",
      Position: new THREE.Vector3(585.723, 3.84, 819.074),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/812ed1aba5984c8ab5f92c528a496a1c/embed",
      offset: 0,
      offsetUp: 35,
      follow: true,
      lowModelCamZoom: 18
    },

    {
      Id: "Annotation_BuchLebenChristiOffen",
      Titel: "Katholisches Gebetbuch (offen)",
      TitelEn: "Catholic prayer book (open)",
      Position: new THREE.Vector3(541.045, 3.84, 844.869),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/cbde974594da40c88dfff1971f611252/embed",
      offset: 0,
      offsetUp: 35,
      follow: true,
      lowModelCamZoom: 18
    },

    {
      Id: "Annotation_BetbuchGeschlossen",
      Titel: "Protestantisches Gebetbuch",
      TitelEn: "Protestant prayer book",
      Position: new THREE.Vector3(452.383, 3.84, 896.058),
      Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/44f60b202abb4a478403410967273c95/embed",
      offset: 0,
      offsetUp: 35,
      follow: true,
      lowModelCamZoom: 18
    },

    {
        Id: "Annotation_BetbuchOffen",
        Titel: "Protestantisches Gebetbuch (offen)",
        TitelEN: "Protestant prayer book (open)",
        Position: new THREE.Vector3(409.249, 3.84, 920.962),
        Rotation: new THREE.Vector3(0.0, 0.0, 0),
        Scale: 1.5,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/7c6d30693e3f4c9581a2e96f404c6ad9/embed",
        offset: 0,
        offsetUp:35,
        follow: true,
        lowModelCamZoom: 20
      },

      {
        Id: "Annotation_Riedl",
        Titel: "Das Riedl",
        TitelEn: "Cushion",
        Position: new THREE.Vector3(591.226, 3.84, 958.596),
        Rotation: new THREE.Vector3(0.0, 0.0, 0),
        Scale: 1.5,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/311676ae2edb4656bee53cb393ecdff6/embed",
        offset: 0,
        offsetUp:30,
        follow: true,
        lowModelCamZoom: 20
      },

      {
        Id: "Annotation_Tracht",
        Titel: "Bürgertracht",
        TitelEn: "Citizen's costume",
        Position: new THREE.Vector3(499.049, 3.84, 1010.83),
        Rotation: new THREE.Vector3(0.0, 0.0, 0),
        Scale: 1.5,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/8f0fc840d7f4458f966cfd1ec3f67b0e/embed",
        offset: 0,
        offsetUp:30,
        follow: true,
        lowModelCamZoom: 40
      },

     



  ];

  
  export const MachtLabels = [
    {
      Id: "Annotation_picGalerieSissi",
      Titel: "Elisabeth von Österreich-Ungarn",
      TitelEn: "Elisabeth of Austria-Hungary",
      Position: new THREE.Vector3(637.011, 20.5651, 386.281),
      Rotation: new THREE.Vector3(0.0,0.0,60.0),
      Scale: 1,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },

    {
      Id: "Annotation_picGalerieKaiserJagdt",
      Titel: "Der Jagdausflug des Kaisers",
      TitelEn: "The Emperor's hunting trip",
      Position: new THREE.Vector3(714.979, 20.5651, 521.325),
      Rotation: new THREE.Vector3(0.0,0.0,60.0),
      Scale: 1,
      isIFrame: false,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },



    {
      Id: "Annotation_Elisabeth",
      Titel: "Mythos Elisabeth",
      TitelEn: "The myth of Elisabeth",
      Position: new THREE.Vector3(638.572, 15.9026, 424.426),
      Rotation: new THREE.Vector3(0.0,0.0,60.0),
      Scale: 2,
      isIFrame: true,
      iFrameUrl:
        "",
      offset: 0,
      offsetUp: 25,
      follow: false,
      lowModelCamZoom: 20
    },
  
    {
      Id: "Annotation_FranzJoseph",
      Titel: "Franz Joseph I.",
      TitelEn: "Franz Joseph I.",
      Position: new THREE.Vector3(682.31, 15.9026, 500.183),
      Rotation: new THREE.Vector3(0.0,0.0,60.0),
      Scale: 1.5,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/dad0bf772c6648fab0350ea186c1fc13/embed",
      offset: 0,
      offsetUp: 25,
      follow: false,
      lowModelCamZoom: 20
    },

    {
        Id: "Annotation_Jagdtasche",
        Titel: "Jagdtasche des Kaisers",
        TitelEn: "Hunting bag of the Emperor",
        Position: new THREE.Vector3(767.012, 14.6823, 548.484),
        Rotation: new THREE.Vector3(0.0,0.0,150.0),
        Scale: 1.5,
        isIFrame: true,
        iFrameUrl:
          "https://sketchfab.com/models/dbc9c21886f7487bb57dea33560e719e/embed",
        offset: 0,
        offsetUp:30,
        follow: false,
        lowModelCamZoom: 15
      }



  ];

  export const ZeitgeschichteLabel  = [
    {
      Id: "Annotation_ZeitgeschichteOne",
      Titel: "Zeitgeschichte 1918 bis 1934",
      TitelEn: "Contemporary history 1918 to 1934",
      Position: new THREE.Vector3(447.375, 29.7564, 113.481),
      Rotation: new THREE.Vector3(0.0,0.0,-30),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
    {
      Id: "Annotation_ZeitgeschichteTwo",
      Titel: "Zeitgeschichte 1934 bis 1939",
      TitelEn: "Contemporary history 1934 to 1939",
      Position: new THREE.Vector3(489.034, 29.7564, 88.8029),
      Rotation: new THREE.Vector3(0.0,0.0,-30),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
    {
      Id: "Annotation_ZeitgeschichteThree",
      Titel: "Zeitgeschiche 1939 bis 1944",
      TitelEn: "Contemporary history 1939 to 1944",
      Position: new THREE.Vector3(528.527, 29.7564, 65.4081),
      Rotation: new THREE.Vector3(0.0,0.0,-30),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
    {
      Id: "Annotation_ZeitgeschichteFour",
      Titel: "Zeitgeschichte 1944 bis 1945",
      TitelEn: "Contemporary history 1944 to 1945",
      Position: new THREE.Vector3(567.352, 29.7564, 42.4087),
      Rotation: new THREE.Vector3(0.0,0.0,-30),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];


  export const BergmannJungsteinzeitLabel  = [
    {
      Id: "Annotation_BergmannJungsteinzeit",
      Titel: "Jungsteinzeit",
      TitelEn: "Neolithic Age",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const SpaetbronzezeitLabel  = [
    {
      Id: "Annotation_SpaetbronzezeitLabel",
      Titel: "Spätbronzezeit",
      TitelEn: "The late Bronze Age",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const HallstattzeitLabel  = [
    {
      Id: "Annotation_HallstattzeitLabel",
      Titel: "Hallstattzeit",
      TitelEn: "Hallstatt period",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const MittelalterLabel  = [
    {
      Id: "Annotation_MittelalterLabel",
      Titel: "Mittelalter",
      TitelEn: "Middle Ages",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  
  export const BergmannLederhoseLabel  = [
    {
      Id: "Annotation_BergmannLederhose",
      Titel: "Salzarbeiter 1900",
      TitelEn: "Salt worker 1900",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  export const BergmannTrachtLabel  = [
    {
      Id: "Annotation_BergmannTracht",
      Titel: "Bergmannstracht",
      TitelEn: "Miner costume",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];

  
  export const ModernerBergmannLabel  = [
    {
      Id: "Annotation_ModernerBergmann",
      Titel: "Bergmann heute",
      TitelEn: "Miner today",
      Position: new THREE.Vector3(271.716, 31.8379, 537.866),
      Rotation: new THREE.Vector3(0.0,0.0,150),
      Scale: 1.5,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/021420cf5803454e9f0174a55452bc5b/embed",
      offset: 0,
      offsetUp: 0,
      follow: false,
      lowModelCamZoom: 20
    },
  ];